const url = '/locations';
const Provider = 'Locations';
const dbModel = 'Locations';

export { url, Provider, dbModel };
